import React, { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { GlobalContext } from "./../contexts";
import { firebaseErrorMap } from "./../config";
import { Grid, Image, Button } from "semantic-ui-react";
import {
  getAuth,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  sendEmailVerification,
} from "firebase/auth";

// const login = async (e) => {
//     e.stopPropagation();
//     e.preventDefault();
//     if (loading) {
//         return;
//     }
//     setLoading(true);
//     try {
//         await signInWithEmailAndPassword(auth, email, password);
//         // addToast("Login Success", { appearance: 'success', autoDismiss: true });

//     }
//     catch (e) {
//         console.log(e.message)
//         addToast(errorMap[e.code] || e.message, { appearance: 'error' });

//     }
//     setLoading(false);
//     console.log(email, password);
// }

// const changePassword = async (e) => {
//     e.stopPropagation();
//     e.preventDefault();
//     if (loading) {
//         return;
//     }
//     setLoading(true);
//     try {
//         await sendPasswordResetEmail(auth, email);
//         addToast("Password reset has been sent to your email", { appearance: 'success', autoDismiss: true });
//     }
//     catch (e) {
//         console.log(e.message)
//         addToast(errorMap[e.code] || e.message, { appearance: 'error' });
//     }
//     setLoading(false);
//     console.log(email, password);
// }

function Login() {
  let navigate = useNavigate();
  const { addToast } = useToasts();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (event, callback) => {
    callback(event.target.value);
  };

  const login = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    console.log("Logging in");
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      await signInWithEmailAndPassword(getAuth(), email, password);
      // addToast("Login Success", { appearance: 'success', autoDismiss: true });
      setMessage("");
    } catch (e) {
      const message = firebaseErrorMap[e.code] || e.message;
      setMessage(message);
    }
    setLoading(false);
    console.log(email, password);
  };

  return (
    <div className="container login">
      <h1>Welcome</h1>
      <form className="form">
        <input
          type="text"
          onChange={(e) => handleChange(e, setEmail)}
          placeholder="Email"
        />
        <input
          type="password"
          onChange={(e) => handleChange(e, setPassword)}
          placeholder="Password"
        />
        <Button
          disabled={loading}
          type="submit"
          id="login-button"
          onClick={login}
          loading={loading}
        >
          Login
        </Button>
        <div className="response-message">{message}</div>
        <Grid columns={4} divided centered>
          <Grid.Row>
            <Grid.Column style={{display: 'flex', justifyContent: 'center'}}>
              <Link
                href="#"
                to="/register"
                style={{ color: "white", fontWeight: "bold" }}
              >
                Register
              </Link>
            </Grid.Column>
            <Grid.Column  style={{display: 'flex', justifyContent: 'center'}}>
              <Link
                href="#"
                to="/password-reset"
                style={{ color: "white", fontWeight: "bold" }}
              >
                Forgot Password?
              </Link>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </form>
    </div>
  );
}
export default Login;
